module.exports = __webpack_public_path__ + "static/media/vadodara.fcdb8afe.jpg";